export default __webpack_public_path__ + "static/media/labourBg@2x.5509f1d3.png";